//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MainNavigation from './mainNavigation';

export default {
  name: 'FirstSection',
  components: {
    MainNavigation,
  },
  props: ['navigationActiveIndex', 'links'],
};
